import React from 'react'
import { List, Datagrid, TextField, Filter, SearchInput, SelectInput, BooleanField, TopToolbar, CreateButton, FunctionField } from 'react-admin'
import { Chip } from '@mui/material'
import Permission from '../../components/Permission'
import { PERMISSIONS } from '../../constants'
import ImportButtom from './SaleImport';
import ListPagination from '../../components/ListPagination'
import RequiredChain from '../../components/RequiredChain'

const Filters = props => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <SelectInput
      label="Status"
      source="isDisabled"
      choices={[{ label: 'Todos', value: 'all' }, { label: 'Ativos', value: 'activated' }, { label: 'Inativos', value: 'disabled' }]}
      optionText="label"
      optionValue="value"
      isRequired
      alwaysOn
    />
  </Filter>
)

const ListActions = () => {
  return (
    <TopToolbar>
      <CreateButton />
      <Permission permission={PERMISSIONS.ADMIN}>
        <ImportButtom />
      </Permission>
    </TopToolbar>
  );
};

const SaleProductsList = props =>
  <Permission permission={PERMISSIONS.CREATE_PRODUCT}>
    <RequiredChain>
      <List
        {...props}
        perPage={25}
        pagination={<ListPagination />}
        exporter={false}
        title="Produtos de Venda"
        filters={<Filters />}
        actions={<ListActions />}
        filterDefaultValues={{ isDisabled: 'all' }}
      >
        <Datagrid rowClick="edit" bulkActionButtons={false}>
          <TextField source="code" label="Código (rede)" />
          <TextField source="name" label="Nome" />
          <FunctionField
            label="Postos c/ código específico"
            render={record => {
              const count = record.saleProductCodes?.length || 0;
              if (count === 0) return null;
              return <Chip label={`${count} posto${count > 1 ? 's' : ''}`} size="small" color="info" variant="outlined" />;
            }}
          />
          <BooleanField source="isDisabled" label="Desativado" textAlign="center" style={{ flexDirection: "column" }} />
        </Datagrid>
      </List>
    </RequiredChain>
  </Permission>

export default SaleProductsList;
